import React from 'react';
import {
    Header,
    Segment,
    Loader,
    Icon,
    Input
} from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import PaginationFront from '../util/PaginationFront';
import Announcements from "../Announcements/Announcements";

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

export default class StudentServiceHome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            results: [],
            loader: true,
            contentIndex: null,
            searchValue: '',
            activePage: 1,
            postsPerPage: 5
        };

        this.fetchData = this.fetchData.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handlePaginationChange = this.handlePaginationChange.bind(this);
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        const locale = window.$locale;
        const bhs = locale === 'bs' || locale === 'sr' || locale === 'hr';

        axios.get('/announcement/by-user-type')
            .then(res => {
                this.setState({
                    data: res.data
                        .sort((a, b) => b.id - a.id)
                        .filter(el => (bhs ? el.title && el.content : el.titleEng && el.contentEng)),
                    loader: false,
                    contentIndex: 0
                });
            })
            .catch(() => {
                this.setState({ loader: false });
            });
    }

    getDataToRender() {
        if (this.state.results.length !== 0 || this.state.searchValue) {
            return this.state.results;
        }
        return this.state.data;
    }

    handleSearchChange(e, { value }) {
        const locale = window.$locale;
        const bhs = locale === 'bs' || locale === 'sr' || locale === 'hr';

        const filtered = this.state.data.filter(el => {
            const title = bhs ? (el.title || '') : (el.titleEng || '');
            const content = bhs ? (el.content || '') : (el.contentEng || '');

            return (
                title.toLowerCase().includes(value.toLowerCase()) ||
                content.toLowerCase().includes(value.toLowerCase())
            );
        });

        this.setState({
            searchValue: value,
            results: value ? filtered : [],
            activePage: 1,
            contentIndex: value ? 0 : this.state.contentIndex
        });
    }

    handlePaginationChange(e, { activePage }) {
        this.setState({ activePage });
    }

    formatDate(dateValue) {
        if (!dateValue) return '';
        const date = new Date(dateValue);
        if (Number.isNaN(date.getTime())) return '';
        return date.toLocaleDateString('bs-BA');
    }

    render() {
        const { loader, activePage, postsPerPage, contentIndex, searchValue } = this.state;

        const locale = window.$locale;
        const bhs = locale === 'bs' || locale === 'sr' || locale === 'hr';

        const allPosts = this.getDataToRender();
        const indexOfLastPost = activePage * postsPerPage;
        const indexOfFirstPost = indexOfLastPost - postsPerPage;
        const currentPosts = allPosts.slice(indexOfFirstPost, indexOfLastPost);

        return (
            <div>
                <Header as="h1">
                    <FormattedMessage id="sidebar.home" />
                </Header>

                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">Obavještenja</Header>
                    </Segment>
                    <Segment>
                        <Announcements noSegment />
                    </Segment>
                </Segment.Group>

                <ToastContainer />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/StudentServiceHome.js